<div class="box-key" *ngIf="this.valueKey">
    <div class="counter" *ngIf="!this.counterFinalizado">
        <i class="fa-solid fa-stopwatch" style="font-size: 16px; color: var(--primary-color);"></i><app-counter-timing [dateTimeTransaction]="this.dateTimeTransation" [fontSize]="'20px'" [minutes]="5" (finalizionCounter)="this.finalizationCounter($event)"></app-counter-timing>
    </div>
    <span class="text-information">Copie o código Pix ou leia o Qrcode, e faça o pagamento no seu banco, antes do tempo expirar.</span>
    
    <div class="input-pix" style="position: relative; display: flex; align-items: center; width: 100%;">
        <input [value]="this.valueKey" disabled style="padding-right: 40px; width: 100%;"/>
        <i class="fa-regular fa-copy" (click)="copyPix(this.valueKey)" style="position: absolute; right: 25px; cursor: pointer; color: var(--primary-color); font-size: 20px;"></i>
    </div>
    
    <div style="text-align: center; margin-bottom: 10px;">
        <span (click)="openQrCodeModal()" style="color: var(--primary-color); font-size: 14px; text-decoration: underline; cursor: pointer; font-weight: 500;">Visualizar Qr Code</span>
    </div>
</div>

<!--Modal Pix-->
<div class="modal" [ngClass]="{'show': openModalPix}">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title" style="font-size: 16px;" id="staticBackdropLabel">Pagamento Pix</h1>
        <button type="button" class="btn-close" (click)="closeQrCodeModal()" aria-label="Close"></button>
      </div>
      <div class="modal-body" style="gap: 10px; padding: 20px;">
        <div class="img-qrCode" style="display: flex; justify-content: center; width: 100%;">
            <qrcode *ngIf="this.valueKey" [qrdata]="this.valueKey" [width]="200" [colorDark]="'#000000'" [colorLight]="'#FFFFFF'"></qrcode>
        </div>

        <span class="text-information">Copie o código Pix ou leia o Qrcode, e faça o pagamento no seu banco, antes do tempo expirar.</span>
    
        <div class="input-pix" style="position: relative; display: flex; align-items: center; width: 100%; padding-bottom: 20px;">
            <input [value]="this.valueKey" disabled style="padding-right: 40px; width: 100%;"/>
            <i class="fa-regular fa-copy" (click)="copyPix(this.valueKey)" style="position: absolute; right: 25px; cursor: pointer; color: var(--primary-color); font-size: 20px;"></i>
        </div>
      </div>
    </div>
  </div>
</div>
